import { Container, Grid, Typography } from '@mui/material';
import img0 from '../../utils/images/aboutUs.jfif';
import img1 from '../../utils/images/aboutUs1.JPG';
import img2 from '../../utils/images/aboutUs2.jfif';
import React from 'react';
import { Navbar } from '../../components/Navbar/Navbar';
import SignupPage from '../SignupPage/SignUp';
import ContactUsForm from './ContactUsFrom';
import Ticker from 'react-ticker';
import Tickers from '../../components/Tickers/Tickers';

const ContactUs = () => {
  return (
    <div>
      <Navbar />
      {/* <Ticker>
        {({ index }) => (
          <>
            <div
              style={{
                backgroundColor: '#FF7345',
                marginTop: '70px',
                color: 'white',
              }}
            >
              <Typography sx={{ fontFamily: 'Sora', marginRight: 2 }}>
                Sample News <></>
              </Typography>
            </div>
          </>
        )}
      </Ticker> */}

      {/* <Tickers></Tickers> */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          height: '457px',
          paddingTop: '100px',
          background: `rgba(0, 0, 0,0.8) url(${img0})`,

          backgroundSize: 'cover',
          position: 'relative',
          backgroundPosition: 'center',
          zIndex: -1,
          flexDirection: 'column',
          backgroundBlendMode: 'darken',

          // marginTop: '20px',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Sora',
            color: '#FCFCFC',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            marginTop: '100px',
            fontWeight: 'bold',
            fontSize: "3.2rem",


          }}
        >
          Contact Us
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: 'Sora',
            color: 'white',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            fontWeight: 'bold',
            fontSize: ['20px', '30px', '30px'],
          }}
        ></Typography>
      </div>

      <ContactUsForm />
    </div>
  );
};

export default ContactUs;
